import * as api from '@api/hub/api-function';
import { useApiMutation } from '@hook/common/useApi';
import { IApiResponse } from '@datatype/common/api-type';
import { ICreateContactRequest } from '@datatype/hub/api-type';

/**
 * ###################################
 * @description hub mutation
 * ###################################
 */

/**
 * @description 문의 및 의견 mutation 함수
 */
export const useCreateContactMutation = () => {
  return useApiMutation<IApiResponse<void>, ICreateContactRequest>(api.createContactApi, {});
};
